export default function defaultClusterFeaturePropertiesFunction(properties, options = {}) {
	if (options.properties) {
		Object.assign(properties, options.properties);
	}

	return properties;
}
